module.exports = __webpack_public_path__ + "static/media/private-nursing.a1c0efe0.jpg";